<template>
    <f-dialog
        :title        = "$t('msd.operator.assign')"
        v-model       = "value"
        :width        = "500"
        :show-header  = "false"
        :hide-actions = "true"
    >
        <template v-slot:content>
            <v-form ref="form" style="position: relative">
                <div style="position: absolute; right: 0" class="pt-1">
                    <a  @click="onCancel" >
                        <v-icon
                            color = "primary"
                            size  = "26"
                        >
                            mdi-close
                        </v-icon>
                    </a>
                </div>
                <v-tabs
                    v-model = "tabs"
                    height="35"
                    class   = "folder-tabs ml-0 mt-2"
                    active-class = "folder-tab-active primary"
                    left
                    style="border-bottom-style: solid; border-width: 1px; border-bottom-color: lightgray"
                >
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab class="folder-tab">
                        Kunde
                    </v-tab>
                    <v-tab class="folder-tab">
                        Verwalter
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs" class="mt-1">
                    <v-tab-item>
                        <company-edit
                            v-if="company"
                            class         = "mb-3"
                            :height       = "439"
                            :company      = "company"
                            :comment-rows = "10"
                            @stored       = "onStored"
                        >
                            <template v-slot:additional>
                                <v-row class="no-frame">
                                    <v-col class="no-frame">
                                        <v-text-field
                                            label          = "Import Name"
                                            v-model        = "company.idname"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                        />
                                    </v-col>
                                </v-row>
                            </template>
                        </company-edit>
                    </v-tab-item>
                    <v-tab-item>
                        <div>
                            <v-text-field
                                hide-details
                                class          = "mt-0 pt-5 mb-3"
                                @input         = "onInput"
                                append-icon    = "fas fa-search"
                                v-model        = "search"
                                :label         = "$t('msd.operator.input')"
                                :clearable     = "true"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </div>

                        <v-container class = "seletable-content pa-0">
                            <company-card
                                v-for       = "(item,index) in selectable"
                                :company    = "item"
                                :key        = "index"
                                :background = "background(item)"
                                class       = "mt-0 mb-2 w-100"
                                @click      = "onCompany(item)"
                            />
                        </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-form>
        </template>
    </f-dialog>
</template>

<script>

import Core        from "@/modules/core/service/Core";
import Company     from "@/modules/msd/company/common/service/Company";
import Customer    from "@/modules/msd/company/customer/service/Customer";
import FDialog     from "@/modules/core/components/utils/FDialog";
import CompanyCard from "@/modules/msd/company/common/components/controlls/CompanyCard.vue";
import CompanyEdit from "@/modules/msd/company/common/components/controlls/CompanyEdit.vue";

export default {
    name: "DOperatorDialog",

    components: {
        CompanyEdit,
        CompanyCard,
        FDialog,
    },

    props: {
        value: {

        },

        customer: {

        }
    },

    data: () => ({
        tabs      : 0,
        show      : false,
        search    : null,
        companies : [],
        selectable: [],
        selected  : [],
        refresh   : 0,
        showSave  : true,
        company   : null,
    }),

    mounted() {
        this.show = this.value;
        this.initialize();
    },

    watch: {
        value () {
            this.show = this.value;
            if (this.show) {
                this.initialize();
            }
        },

        tabs () {
            this.showSave = this.tabs === 0;
        }
    },

    computed: {
    },

    methods: {
        initialize () {
            if (!this.customer) {
                return;
            }

            this.selected = [];
            Company.companiesByRoles([Company.roles.facilityAdmin]).then(data => {
                this.companies = data;
                this.selectable = this.companies;
            });

            Customer.companies(this.customer.id, (data) => {
                this.selected = data;
            });

            this.company = {
                id : null,
                name : this.companyName,
                nameAdd : null,
                street : null,
                zip : null,
                city : null,
                weburl : null,
                comment : null,
                clazz : "ServiceCompanyDto",
                parent:  {
                    clazz : "CustomerDto",
                    id: this.customer.id,
                    name: this.customer.name
                },
                status : {
                    id: 1,
                    name: ""
                },
                country : {
                    id: 1,
                    name: ""
                },
                roles: [
                    {
                        id: Company.roles.customercompany
                    }
                ]
            };
        },

        onCancel () {
            this.$emit("input", false);
        },

        onStored (company) {
            this.$emit("refresh", company);
            this.onCancel();
        },

        onCompany (company) {
            const index = this.selected.findIndex(c => c.id === company.id);
            if (index >= 0) {
                console.log("unassign", company);
                Customer.unassign(this.customer.id, company.id).then ((data) => {
                    if (!data.contacts) {
                        this.selected.splice(index, 1);
                        Core.message.hint(this, "Zuordnung entfernt")
                        this.$emit("refresh", company)
                    } else {
                        Core.message.error(this, "Kontakte")
                    }
                })
            } else {
                console.log("assign", company);
                Customer.assign(this.customer.id, company.id).then ((data) => {
                    if (!data.exists) {
                        this.selected.push(company)
                        Core.message.hint(this, "Zuordnung ok")
                        this.$emit("refresh", company)
                    }
                })
            }
        },

        onInput () {
            if (!this.search || this.search.length === 0) {
                this.selectable = this.companies;
                return;
            }

            return this.companies.filter(c => this.filter(c))
        },

        filter (item) {
            if (Core.filter.includes(item.name, this.search)) {
                return true;
            }

            return false;
        },

        background (company) {
            const hit = this.selected.find (c => c.id === company.id);
            if (hit) {
                return "background-selected"
            }

            return null;
        }
    }
}
</script>

<style scoped>

.seletable-content {
    max-height: 390px;
    min-height: 390px;
    overflow-y: scroll;
    padding-right: 5px;
    padding-left: 0;
    width: calc(100% + 8px);
}

</style>